import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-ajouter-diffusion-confirmation-dialog',
    templateUrl: './ajouter-diffusion-confirmation-dialog.component.html',
    styleUrls: ['./ajouter-diffusion-confirmation-dialog.component.scss'],
    imports: [
    MatDialogModule,
    TranslateModule,
    MatIconModule
]
})
export class AjouterDiffusionConfirmationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<AjouterDiffusionConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      success: boolean;
      errorMessage?: string;
    }
  ) { }

  onClose(): void {
    this.dialogRef.close();
  }
}
